const tamanhoMinimoNumeroOab = 2;
export const tamanhoMaximoNumeroOab = 20;

export function normalizarOabNumero(valor: string): string {
  return valor.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

export function oabNumeroValido(valor: string): boolean {
  const normalizado = normalizarOabNumero(valor);
  return (
    normalizado.length >= tamanhoMinimoNumeroOab && normalizado.length <= tamanhoMaximoNumeroOab
  );
}
